<template>
	<div class="date-filter">
		<div>
			<div class="field has-addons">
				<div class="control ONEW">
					<o-button
						v-if="false"
						variant="primary"
						:class="{ selected: picker.selection == '1W' }"
						outlined
						@click="picker.selection = '1W'">
						1W
					</o-button>
				</div>
				<div class="control ONEM">
					<o-button
						variant="primary"
						:class="{ selected: picker.selection == '1M' }"
						outlined
						@click="picker.selection = '1M'">
						1M
					</o-button>
				</div>
				<div class="control THREEM">
					<o-button
						variant="primary"
						:class="{ selected: picker.selection == '3M' }"
						outlined
						@click="picker.selection = '3M'">
						3M
					</o-button>
				</div>
				<div class="control SIXM">
					<o-button
						variant="primary"
						:class="{ selected: picker.selection == '6M' }"
						outlined
						@click="picker.selection = '6M'">
						6M
					</o-button>
				</div>
				<div class="control YTD">
					<o-button
						variant="primary"
						:class="{ selected: picker.selection == 'YTD' }"
						outlined
						@click="picker.selection = 'YTD'">
						YTD
					</o-button>
				</div>
				<div class="control LY">
					<o-button
						variant="primary"
						:class="{ selected: picker.selection == 'LY' }"
						outlined
						@click="picker.selection = 'LY'">
						LY
					</o-button>
				</div>
				<div class="control ONEY">
					<o-button
						variant="primary"
						:class="{ selected: picker.selection == '1Y' }"
						outlined
						@click="picker.selection = '1Y'">
						1Y
					</o-button>
				</div>
				<div class="control TWOY">
					<o-button
						variant="primary"
						:class="{ selected: picker.selection == '2Y' }"
						outlined
						@click="picker.selection = '2Y'">
						2Y
					</o-button>
				</div>
				<div class="control CUSTOM">
					<o-button
						variant="primary"
						:class="{ selected: picker.selection == 'Custom' }"
						outlined
						@click="picker.selection = 'Custom'">
						Custom
					</o-button>
				</div>
			</div>
		</div>
		<div v-show="picker.selection === 'Custom'">
			<div class="is-flex">
				<o-field label="Start Date" class="mr-3 start-date">
					<o-datepicker
						v-model="startDate"
						placeholder="Start Date"
						icon="calendar"
						:min-date="minDate"
						:max-date="maxDate"
						trap-focus
						@active-change="EOD"></o-datepicker>
				</o-field>
				<o-field label="End Date" class="end-date">
					<o-datepicker
						v-model="endDate"
						placeholder="End Date"
						icon="calendar"
						:min-date="minDate"
						:max-date="maxDate"
						trap-focus
						@active-change="EOD"></o-datepicker>
				</o-field>
			</div>
		</div>
	</div>
</template>
<script>
	import { ref, computed, watch, inject, onMounted, nextTick } from "vue";
	export default {
		props: {
			modelValue: {
				type: Object,
				default: () => {
					return null;
				}
			},
			reportType: {
				type: String,
				default: null
			}
		},
		emits: ["update:modelValue"],
		setup(props, context) {
			const moment = inject("$moment");
			const $store = inject("$store");
			const user = ref($store.getters.user);

			const picker = ref(
				props.modelValue || {
					startDate: moment.utc().add(-1, "year").startOf("day").toDate(),
					endDate: moment.utc().endOf("day").toDate(),
					selection: "1Y"
				}
			);
			const startDate = ref(moment().add(-1, "year").startOf("day").toDate());
			const endDate = ref(moment().endOf("day").toDate());

			const minDate = ref(moment("2008-01-01").toDate());
			const maxDate = ref(moment().toDate());

			if (props.reportType == "User" && user.value.SiteAdmin)
				maxDate.value = moment().add(1, "year").toDate();

			const UpdateDateRange = (selection) => {
				switch (selection) {
					case "1W": {
						picker.value.startDate = moment.utc().subtract(7, "day").startOf("day").toDate();
						picker.value.endDate = moment.utc().endOf("day").toDate();

						startDate.value = moment().subtract(7, "day").startOf("day").toDate();
						endDate.value = moment().endOf("day").toDate();
						break;
					}
					case "1M": {
						picker.value.startDate = moment.utc().subtract(1, "months").startOf("day").toDate();
						picker.value.endDate = moment.utc().endOf("day").toDate();

						startDate.value = moment().subtract(1, "months").startOf("day").toDate();
						endDate.value = moment().endOf("day").toDate();
						break;
					}
					case "3M": {
						picker.value.startDate = moment.utc().subtract(3, "months").startOf("day").toDate();
						picker.value.endDate = moment.utc().endOf("day").toDate();

						startDate.value = moment().subtract(3, "months").startOf("day").toDate();
						endDate.value = moment().endOf("day").toDate();
						break;
					}
					case "6M": {
						picker.value.startDate = moment.utc().subtract(6, "months").startOf("day").toDate();
						picker.value.endDate = moment.utc().endOf("day").toDate();

						startDate.value = moment().subtract(6, "months").startOf("day").toDate();
						endDate.value = moment().endOf("day").toDate();
						break;
					}
					case "YTD": {
						picker.value.startDate = moment.utc().startOf("year").startOf("day").toDate();
						picker.value.endDate = moment.utc().endOf("day").toDate();

						startDate.value = moment().startOf("year").startOf("day").toDate();
						endDate.value = moment().endOf("day").toDate();
						break;
					}
					case "LY": {
						picker.value.startDate = moment
							.utc()
							.subtract(1, "years")
							.startOf("year")
							.startOf("day")
							.toDate();
						picker.value.endDate = moment
							.utc()
							.subtract(1, "years")
							.endOf("year")
							.endOf("day")
							.toDate();

						startDate.value = moment().subtract(1, "years").startOf("year").startOf("day").toDate();
						endDate.value = moment().subtract(1, "years").endOf("year").endOf("day").toDate();
						break;
					}
					case "1Y": {
						picker.value.startDate = moment.utc().subtract(1, "years").startOf("day").toDate();
						picker.value.endDate = moment.utc().endOf("day").toDate();

						startDate.value = moment().subtract(1, "years").startOf("day").toDate();
						endDate.value = moment().endOf("day").toDate();
						break;
					}
					case "2Y": {
						picker.value.startDate = moment.utc().subtract(2, "years").startOf("day").toDate();
						picker.value.endDate = moment.utc().endOf("day").toDate();

						startDate.value = moment().subtract(2, "years").startOf("day").toDate();
						endDate.value = moment().endOf("day").toDate();
						break;
					}
					case "Custom": {
						break;
					}
					default: {
						console.error("Invalid selection.");
						break;
					}
				}
			};

			const EOD = (isOpen) => {
				if (!isOpen) {
					picker.value.startDate = moment(startDate.value).utc().startOf("day").toDate();
					picker.value.endDate = moment(endDate.value).utc().endOf("day").toDate();
					UpdateModel();
				}
			};

			const UpdateModel = (force = false) => {
				if (!force) return;
				context.emit("update:modelValue", picker.value);
			};

			watch(
				() => picker.value.selection,
				(n, o) => {
					UpdateDateRange(n);
					UpdateModel();
				}
			);

			watch(
				() => props.modelValue,
				(n, o) => {
					if (n != o) {
						if (typeof n.startDate === "string") {
							const d = n.startDate.split("T")[0];
							startDate.value = moment(d).toDate();
							picker.value.startDate = moment(startDate.value).utc().startOf("day").toDate();
						} else {
							startDate.value = moment(
								moment.utc(n.startDate).format("YYYY-MM-DDT").split("T")[0]
							).toDate();
							picker.value.startDate = moment.utc(startDate.value).startOf("day").toDate();
						}

						if (typeof n.endDate === "string") {
							const d = n.endDate.split("T")[0];
							endDate.value = moment(d).toDate();
							picker.value.endDate = moment(endDate.value).utc().endOf("day").toDate();
						} else {
							endDate.value = moment(
								moment.utc(n.endDate).format("YYYY-MM-DDT").split("T")[0]
							).toDate();
							picker.value.endDate = moment.utc(endDate.value).endOf("day").toDate();
						}

						picker.value.selection = n.selection;
						//UpdateModel(true);
					}
				},
				{ immediate: true }
			);

			return {
				picker,
				startDate,
				endDate,
				EOD,
				minDate,
				maxDate
			};
		}
	};
</script>
<style lang="scss" scoped>
	@import "@/assets/css/globalVars.scss";

	button.button.is-outlined.selected {
		background-color: $boyden-blue;
		color: white;
	}

	.field.has-addons {
		display: flex;
		flex-wrap: wrap;
		//border: 1px solid $boyden-blue;
		border-radius: $radius-small;
		box-sizing: content-box;

		& > .control {
			display: inline-block;
			border-top: 1px solid $boyden-blue;
			border-bottom: 1px solid $boyden-blue;
			margin-bottom: -1px;
			border-right: 1px solid $boyden-blue;
			margin-right: -1px;

			&:last-child {
				border-right: 1px solid $boyden-blue;
				margin-right: -1px;
			}
		}

		& > .control:not(:first-child) {
			& button.button.is-outlined {
				border-left: 1px solid $boyden-blue;
			}
		}

		& button.button.is-outlined {
			border: none;

			&:hover {
				border-left-color: transparent !important;
				background-color: $boyden-blue-light;
			}
		}
	}
</style>
